import customerInstance from '../instance'

const getDeliveryPeriods = () => {
	return customerInstance.get('/deliveryPeriods')
}

export default getDeliveryPeriods